module.exports = __webpack_public_path__ + "static/media/pix_disabled.960f7abc.svg";